import { EpiOrderStatuses } from '@services';

export type CartProduct = {
    id: number;
    quantity: number;
};

export type CreateOrderPayload = {
    operator_id: number;
    id_worksite: number;
    date_order: string;
    comment: string;
    products: CartProduct[];
};

export type UpdateOrderPayload = {
    id_order: number;
    operator_id: number;
    id_worksite: number;
    date_order: string;
    comment: string;
    products: CartProduct[];
};

export type DeleteOrderPayload = {
    id_order: number;
};

export type OrderProduct = {
    id: string;
    quantity: string;
    id_category: string;
    label: string;
    image: string;
    packing_unit: string;
    available: string;
};

export type Order = {
    id: string;
    id_operator: number;
    id_worksite: number;
    date_order: string;
    date_update?: string;
    comment: string;
    status: OrderStatuses | EpiOrderStatuses;
    products: OrderProduct[];
};

export type GetOrdersResponse = Order[];
export type CreateOrderResponse = Order;
export type UpdateOrderResponse = Order;
export type DeleteOrderResponse = {
    success: boolean;
    message: string;
};

export enum OrderStatuses {
    CREATED = '1',
    CONFIRMED = '2',
    VALIDATED = '3',
    DELETED = '4',
    FAVORITED = '5',
    SYNCHRONIZED = '6',
    UPDATED = '7'
}
